import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import NavigateNext from '@material-ui/icons/NavigateNext';
import { Link } from 'react-router-dom';
import { Translation } from 'react-i18next';

import headerBackground from '../Images/header-background.png';
import Footer from '../components/Footer';
import { useEffect } from 'react';

let styles = (theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
    },
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(4),
    minWidth: 350,
    maxWidth: 1000,
  },
  button: {
    marginTop: theme.spacing(2),
  },
  headerContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  titleStyle: {
    color: '#ffffff',
    fontWeight: 'bold',
  },
  subTitle: {
    color: '#4CAF50',
    fontWeight: 'bold',
  },
  warningText: {
    color: '#4CAF50',
  },
  buttonApplications: {
    fontWeight: 'bold',
    color: '#F9F9F9',
    backgroundColor: '#2a3eb1',
    margin: theme.spacing(1),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingTop: theme.spacing(1.1),
    paddingBottom: theme.spacing(1.1),
    fontSize: 18,
  },
  itemMidContainer: {
    marginTop: theme.spacing(10),
  },
});

let sectionStyle = {
  height: '345px',
  backgroundImage: `url(${headerBackground})`,
};

function PaymentLinkSent(props) {
  let { classes, onClose } = props;

  useEffect(
    () => () => {
      onClose();
    },
    [onClose]
  );

  return (
    <Translation>
      {(t) => {
        return (
          <div>
            <Grid
              container
              alignItems="center"
              justifyContent="center"
              direction="row"
            >
              <Grid
                className={classes.headerContainer}
                style={sectionStyle}
                item
                xs={12}
              >
                <Typography
                  className={classes.titleStyle}
                  variant="h3"
                  align="center"
                  gutterBottom
                >
                  {t('onlineServices')}
                </Typography>
              </Grid>
              <Grid className={classes.itemMidContainer}>
                <Paper className={classes.root} elevation={3}>
                  <Typography
                    className={classes.subTitle}
                    align="center"
                    variant="h4"
                  >
                    {t('paymentLinkSent')}
                  </Typography>
                </Paper>
                <Grid
                  container
                  alignItems="center"
                  justifyContent="flex-end"
                  direction="row"
                >
                  <Button
                    variant="contained"
                    className={classes.buttonApplications}
                    component={Link}
                    to="/applications"
                  >
                    {t('goToApplications')}
                    <NavigateNext className={classes.rightIcon} />
                  </Button>
                </Grid>
              </Grid>
            </Grid>
            <Footer />
          </div>
        );
      }}
    </Translation>
  );
}
export default withStyles(styles)(PaymentLinkSent);



// WEBPACK FOOTER //
// ./src/view/scenes/Payment/PaymentLinkSent.js